import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface IdleTimeOutModalProps {
  showModal: boolean;
  handleContinue: () => void;
  handleLogout: () => void;
  remainingTime: string;
}

export const IdleTimeOutModal: React.FC<IdleTimeOutModalProps> = ({
  showModal,
  handleContinue,
  handleLogout,
  remainingTime
}) => {
  return (
    <Modal 
      show={showModal} 
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header>
        <Modal.Title>Session Timeout Warning</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Your session will expire in <strong>{remainingTime}</strong> due to inactivity.</p>
        <p>Click "Continue" to extend your session, or "Logout" to end your session now.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleLogout}>
          Logout
        </Button>
        <Button variant="primary" onClick={handleContinue}>
          Continue Session
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default IdleTimeOutModal;
